declare module 'equivalent-key-map' {
	class EquivalentKeyMap< K, V > extends Map< K, V > {}
	export = EquivalentKeyMap;
}
